
<div class="container-fluid py-3 py-sm-5">
	<h2>Input Compare</h2>
	<dx-data-grid [dataSource]="opimisationChanges$ | async" height="80vh" [showColumnLines]="true" [showRowLines]="true" 
	[showBorders]="true" [rowAlternationEnabled]="true" [allowColumnResizing]="true" [allowColumnReordering]="true">
		<dxo-search-panel [visible]="true"></dxo-search-panel>
		<dxo-column-chooser [enabled]="true" mode="select">
			<dxo-position
				my="right top"
				at="right bottom"
				of=".dx-datagrid-column-chooser-button">
			</dxo-position>
		</dxo-column-chooser>
		<dxo-grouping [contextMenuEnabled]="true"></dxo-grouping>
		<dxo-group-panel [visible]="!phone"></dxo-group-panel>
		<dxo-toolbar>
			<dxi-item name="groupPanel"></dxi-item>
			<dxi-item name="searchPanel"></dxi-item>
			<dxi-item name="columnChooserButton"></dxi-item>
		</dxo-toolbar>
		<dxo-scrolling mode="virtual"></dxo-scrolling>
		<dxo-header-filter [visible]="true"></dxo-header-filter>
		<dxo-sorting mode="multiple"></dxo-sorting>
		<dxi-column dataField="comparisonDate" dataType="date" [minWidth]="175" [format]="dateTimeFormat" [groupIndex]="0" sortOrder="desc">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
		<dxi-column dataField="optimisationComparisonId" caption="Comparison Id" [visible]="false">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
		<dxi-column dataField="beforeFile" [minWidth]="175">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
		<dxi-column dataField="afterFile" [minWidth]="175">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
		<dxi-column dataField="changeDate" dataType="date" [minWidth]="175" [format]="dateTimeFormat">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
		<dxi-column dataField="initiatedBy" caption="Compared By">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
		<dxi-column dataField="source"></dxi-column>
		<dxi-column dataField="changeType"></dxi-column>
		<dxi-column dataField="description">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
		<dxi-column dataField="tradeId">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
		<dxi-column dataField="allegroId">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
		<dxi-column dataField="field">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
		<dxi-column dataField="beforeValue">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
		<dxi-column dataField="afterValue">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
		<dxi-column dataField="remarks">
			<dxo-header-filter [allowSelectAll]="false">
				<dxo-search [enabled]="true"></dxo-search>
			</dxo-header-filter>
		</dxi-column>
	</dx-data-grid>
</div>
